(() => {
 function mount(header){
  if(header.dataset.cpReady)return;header.dataset.cpReady='true';
  const abort=new AbortController(),{signal}=abort;
  const menu=header.querySelector('[data-cp-menu]');
  const menuTrigger=header.querySelector('[data-cp-menu-open]');
  const searchTrigger=header.querySelector('[data-cp-search-open]');
  let active=null,trigger=null,saved=null,scrollY=0;
  const viewport=()=>{
   const v=window.visualViewport;
   document.documentElement.style.setProperty('--cp33-overlay-height',`${Math.round(v?.height||innerHeight)}px`);
   document.documentElement.style.setProperty('--cp33-overlay-top',`${Math.round(v?.offsetTop||0)}px`);
  };
  const unlock=()=>{
   if(!saved)return;Object.assign(document.body.style,saved);saved=null;
   document.documentElement.removeAttribute('data-cp-overlay-open');window.scrollTo({top:scrollY,behavior:'instant'});
   const returnTo=trigger;active=null;trigger=null;returnTo?.focus({preventScroll:true});
  };
  const open=(dialog,button)=>{
   if(!dialog||dialog.open)return;
   if(active){active.removeEventListener('close',unlock);if(active.open)active.close();unlock();}
   scrollY=window.scrollY;saved={position:document.body.style.position,top:document.body.style.top,left:document.body.style.left,right:document.body.style.right,width:document.body.style.width,overflow:document.body.style.overflow};
   Object.assign(document.body.style,{position:'fixed',top:`-${scrollY}px`,left:'0',right:'0',width:'100%',overflow:'hidden'});
   document.documentElement.setAttribute('data-cp-overlay-open','');trigger=button;active=dialog;viewport();
   dialog.addEventListener('close',unlock,{once:true});
   dialog.showModal();
   (dialog===menu ? dialog.querySelector('[data-cp-menu-close]') : dialog.querySelector('input[name="q"]'))?.focus({preventScroll:true});
   dialog.scrollTop=0;const scroller=dialog.querySelector('.cp33-menu__body');if(scroller)scroller.scrollTop=0;
  };
  header.querySelector('[data-cp-menu-search]')?.addEventListener('click',()=>open(document.querySelector('#search-modal dialog'),searchTrigger),{signal});
  menuTrigger?.addEventListener('click',()=>open(menu,menuTrigger),{signal});
  header.querySelector('[data-cp-menu-close]')?.addEventListener('click',()=>menu.close(),{signal});
  searchTrigger?.addEventListener('click',()=>open(document.querySelector('#search-modal dialog'),searchTrigger),{signal});
  menu?.addEventListener('click',e=>{
   const r=menu.getBoundingClientRect();if(e.target===menu&&(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom))menu.close();
   if(e.target.closest('a[href]'))menu.close();
  },{signal});
  // Search close works even while the theme's dialog module is loading.
  document.addEventListener('click',e=>{if(active&&e.target.closest('#search-modal button[aria-label="Close search"]')){e.preventDefault();active.close();}},{signal});
  const menus=[...header.querySelectorAll('[data-cp-mega]')];
  menus.forEach(m=>m.addEventListener('toggle',()=>{if(m.open)menus.forEach(other=>{if(other!==m)other.open=false})},{signal}));
  document.addEventListener('click',e=>menus.forEach(m=>{if(!m.contains(e.target))m.open=false}),{signal});
  document.addEventListener('keydown',e=>{if(e.key==='Escape')menus.forEach(m=>{if(m.open){m.open=false;m.querySelector('summary').focus()}})},{signal});
  const update=()=>{document.body.style.setProperty('--header-height',`${header.offsetHeight}px`);document.body.style.setProperty('--header-group-height',`${header.offsetHeight}px`);document.body.style.setProperty('--transparent-header-offset-boolean','0');};
  const observer=new ResizeObserver(update);observer.observe(header);update();viewport();
  window.addEventListener('resize',viewport,{signal});window.visualViewport?.addEventListener('resize',viewport,{signal});window.visualViewport?.addEventListener('scroll',viewport,{signal});
  header.cpCleanup=()=>{active?.close();unlock();observer.disconnect();abort.abort();};
 }
 document.querySelectorAll('[data-cp-header]').forEach(mount);
 document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-cp-header]').forEach(mount));
 document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-cp-header]').forEach(h=>h.cpCleanup?.()));
})();
